import React, { useEffect, useMemo } from 'react';
import { Outlet, useLocation } from 'react-router-dom';

import interviewApp from '../InterviewApp.module.css';

/**
 * Root shell for the candidate app: the sizing wrapper, the Suspense boundary
 * every code-split page resolves behind, and the viewport tuning below.
 */
export const Layout = () => {
  const location = useLocation();

  const noZoomRoutes = useMemo(() => ['/web-interview'], []);

  useEffect(() => {
    const viewport = document.querySelector('meta[name="viewport"]');
    if (!viewport) return;

    // Check if current path matches any no-zoom routes
    const shouldDisableZoom = noZoomRoutes.some((route) =>
      location.pathname.startsWith(route)
    );

    if (shouldDisableZoom) {
      viewport.setAttribute(
        'content',
        'width=device-width, initial-scale=1, maximum-scale=1, minimum-scale=1, user-scalable=no, viewport-fit=cover'
      );
    } else {
      viewport.setAttribute(
        'content',
        'width=device-width, initial-scale=1, viewport-fit=cover'
      );
    }
  }, [location.pathname, noZoomRoutes]);

  return (
    <div className={interviewApp.shell}>
      <React.Suspense fallback={null}>
        <Outlet />
      </React.Suspense>
    </div>
  );
};
